export const language = [{
        text: '英中',
        value: "英->中",
    }, {
        text: '中英',
        value: "中->英",
    },
    {
        text: '日中',
        value: "日->中",
    },
    {
        text: '中日',
        value: "中->日",
    },
    {
        text: '韩中',
        value: "韩->中",
    },
    {
        text: '中韩',
        value: "中->韩",
    },
    {
        text: '德中',
        value: "德->中",
    },
    {
        text: '中德',
        value: "中->德",
    },
    {
        text: '法中',
        value: "法->中",
    },
    {
        text: '中法',
        value: "中->法",
    },
    {
        text: '中阿',
        value: "中->阿拉伯",
    },
    {
        text: '阿中',
        value: "阿拉伯->中",
    },
    {
        text: '中印',
        value: "中->印尼",
    },
    {
        text: '印中',
        value: "印尼->中",
    },
    {
        text: '中荷',
        value: "中->荷兰",
    },
    {
        text: '荷中',
        value: "荷兰->中",
    },{
        text: '中葡',
        value: "中->葡萄牙",
    },
    {
        text: '葡中',
        value: "葡萄牙->中",
    },{
        text: '中土',
        value: "中->土而其",
    },{
        text: '土->中',
        value: "土耳其->中",
    },{
        text: '中俄',
        value: "中->俄罗斯",
    },{
        text: '俄中',
        value: "俄罗斯->中",
    },{
        text: '中西',
        value: "中->西班牙",
    },{
        text: '西中',
        value: "西班牙->中",
    },{
        text: '中越',
        value: "中->越南",
    },{
        text: '越中',
        value: "越南->中",
    }

]
export const domains = [{
        text: '日常',
        value: "1",
    },
    {
        text: '机械',
        value: "2",
    },
    {
        text: '电子',
        value: "3",
    },
    {
        text: '电器',
        value: "4",
    },
    {
        text: '机电',
        value: "5",
    },
    {
        text: '通信',
        value: "6",
    },
    {
        text: '网络',
        value: "7",
    },
    {
        text: '物理',
        value: "8",
    },
    {
        text: '化学',
        value: "9",
    },
    {
        text: '化工',
        value: "10",
    },
    {
        text: '医药',
        value: "11",
    },
    {
        text: '生化',
        value: "12",
    },
    {
        text: '自动化',
        value: "13",
    },
    {
        text: '计算机',
        value: "14",
    }
]
export const flows = [{
        text: '翻译',
        value: "1"
    },
    {
        text: '翻译+校对',
        value: "2"
    },
    {
        text: '翻译+校对+审核',
        value: "3"
    }
]
export const fileTypes = [
    {
        text: '原稿文件',
        value: "发送,指示文件夹"
    },
    {
        text: '翻译',
        value: "翻译"
    },
    {
        text: '校对',
        value: "校对"
    },
    {
        text: 'PM反馈表',
        value: "PM反馈表"
    },
    {
        text: '返稿文件',
        value: "返稿文件"
    }
]
export const firm = [{
        text: '隆天',
        value: "隆天"
    },
    {
        text: '三友',
        value: "三友"
    },
    {
        text: '中原信达',
        value: "中原信达"
    }
]
export const periods = [{
        text: '一般',
        value: "3"
    },
    {
        text: '加急',
        value: "4"
    },
    {
        text: '特急',
        value: "5"
    }
]

export const patInfo1 = [{
        text: '软件版本',
        value: "Aitrans-PAT 6.0"
    },
    {
        text: '软件厂商',
        value: "环宇爱译"
    },
    {
        text: '软件授权',
        value: "免费"
    },
    {
        text: '应用平台',
        value: "WinAll"
    }
]

export const patInfo2 = [{
        text: '软件大小',
        value: "81.68MB"
    },
    {
        text: '软件语言',
        value: "简体中文"
    },
    {
        text: '软件评级',
        value: 4
    },
    {
        text: '更新时间',
        value: "2021-05-24"
    }
]

export const topUrl = [{
    name: '5-1',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toSoftwareTranslation.do'
}, {
    name: '5-2',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toInstructions.do'
}, {
    name: '5-3',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toUse.do'
}, {
    name: '5-4',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toFunction.do'
}, {
    name: '5-5',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toMenu.do'
}, {
    name: '6-1',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toOA.do'
}, {
    name: '6-2',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toQuality.do'
}, {
    name: '6-3',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toRuleDescription.do'
}, {
    name: '6-4',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toSecurityCenter.do'
}, {
    name: '6-5',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toCustomerInstructions.do'
}, {
    name: '6-6',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toInterpreterTips.do'
}, {
    name: '6-7',
    url: 'http://global.aitrans.org.cn/old/forwardAction/forward_toTranslationProcess.do'
}, {
    name: '4',
    url: 'http://global.aitrans.org.cn/old/cilentCustomer/findNeedListUI.do'
}]

export const bUrl = 'http://localhost:8080/#/'

export const educations = [{
    text: '大专',
    value: "大专"
},
    {
        text: '本科',
        value: "本科"
    },
    {
        text: '硕士',
        value: "硕士"
    },
    {
        text: '博士',
        value: "博士"
    },
    {
        text: '其它',
        value: "其它"
    }
]
